import portfolio from '../assets/images/Project_img/portfolio.jpg';
import farmerFamily from '../assets/images/Project_img/farmerFamily.jpg';
import tranquilTreks from '../assets/images/Project_img/tranquilTreks.jpg';
import commutify from '../assets/images/Project_img/commutify.jpg';
import meetingManager from '../assets/images/Project_img/meetingManager.jpg';
import excerciseTimer from '../assets/images/Project_img/excerciseTimer.jpg';
import beatMaker from '../assets/images/Project_img/beatMaker.jpg';
import instaBooking from '../assets/images/Project_img/instaBooking.png';

export const ProjectData = [
    {
        name: "Portfolio Website",
        desc: "A website made with react.js for online representation of my work, skills and experiences.",
        photo: portfolio,
        type: ["react"],
        link: "www.devanshbatra.in"
    },
    {
        name: "Grocercy App",
        desc: "App made for grocery-ordering for the company farmers family.",
        photo: farmerFamily,
        type: ["reactNative"],
        link: "https://play.google.com/store/apps/details?id=com.app.farmersfamily&hl=en_IN&gl=US"
    },
    {
        name: "Insta Booking",
        desc: " A hotel booking website with real time room booking updation.",
        photo: instaBooking,
        type: ["fullStack"],
        link: "https://fluffy-cuchufli-8b84f4.netlify.app/"
    },
    {
        name: "Chat Website",
        desc: "Features real-time chat within rooms, user can create a chat room with a unique name. ",
        photo: commutify,
        type: ["fullStack", "react"],
        link: "https://devanshbatra.github.io/chatApp/"
    },
    {
        name: "Meeting Manager",
        desc: "Helps to schedule meetings with all details like - agenda, time, motive, notes.",
        photo: meetingManager,
        type: ["reactNative"],
        link: "https://github.com/devanshbatra/MeetingManager"
    },
    {
        name: "Excercise Timer",
        desc: "A progressive web app that makes preset time intervals for excercise sessions and rests with alert tones.",
        photo: excerciseTimer,
        type: ["react", "basic"],
        link: "https://brave-clarke-386c4d.netlify.app/"
    },
    {
        name: "Beat Maker",
        desc: "Create your own beat by experimenting with different drums.",
        photo: beatMaker,
        type: ["basic"],
        link: "https://devanshbatra.github.io/beatmaker/index.html"
    },
]